import React from 'react';
import ChangeField from "./ChangeField";

const ChangeFieldList = ({
                          index,
                          controlId,
                          properties,
                          status,
                          hiddenPropertyNames,
                          displayOnlyPropertyNames,
                          activeEventKey
                      }) => {
    return properties.map((p, propertyIndex) => {
            return hiddenPropertyNames.some(x => x === p.propertyName) ?
                null
                :
                <ChangeField key={propertyIndex}
                          property={p}
                          readOnly={status !== "Undecided" || displayOnlyPropertyNames.some(x => x === p.propertyName)}
                          controlId={`${controlId}.properties[${propertyIndex}]`}
                          expanded={activeEventKey === index.toString()}
                />
        }
    ).filter(x => x != null).sort((a, b) => {
        return a.props.property.displayOrder - b.props.property.displayOrder
    });
}

export default ChangeFieldList;